import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useWorld } from "@/context/WorldContext";
import { findByTitle } from "@/lib/api";
import { renderRich } from "@/lib/richtext";

export const RichContent = ({ html }) => {
  const { pages, basePath, readOnly } = useWorld();
  const nav = useNavigate();
  const out = useMemo(() => renderRich(html, pages, readOnly), [html, pages, readOnly]);
  const click = (e) => {
    const el = e.target.closest("[data-wiki]");
    if (!el) return;
    const target = findByTitle(pages, el.dataset.wiki);
    nav(target ? `${basePath}/p/${target.id}` : `${basePath}/new?title=${encodeURIComponent(el.dataset.wiki)}`);
  };
  return <div className="wiki-prose" data-testid="wiki-content" onClick={click} dangerouslySetInnerHTML={{ __html: out }} />;
};
